/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementFinancialDiscountViewModel } from "../types/CourseRegistrationManagementFinancialDiscountViewModel.ts";

export const courseRegistrationManagementFinancialDiscountViewModelSchema =
  z.object({
    discountTypeText: z
      .string()
      .describe("Tipo de desconto aplicado.")
      .nullish(),
    percentage: z
      .number()
      .describe("Percentual de desconto aplicado. Opcional.")
      .nullish(),
    description: z
      .string()
      .describe("Descrição detalhada do desconto. Opcional.")
      .nullish(),
    companyName: z
      .string()
      .describe("Nome da empresa vinculada ao desconto. Opcional.")
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationManagementFinancialDiscountViewModel>;
